module.exports = require('./dist/identity');
